export const MUTATION_UPDATE_USER = /* GraphQL */ `
	mutation ($input: UserUpdate!, $sub: String!) {
		updateUser(input: $input, sub: $sub) {
			email
			phone_number
			sub
			username
			userStatus
		}
	}
`;
